module.exports = __webpack_public_path__ + "img/fbk.f85732c2.png";